const BASE_DOMAIN = Object.freeze({
  PRODUCTION: 'squareup.com',
  STAGING: 'squareupstaging.com',
});

const getEnvironment = () => {
  const envMeta = document.querySelector("meta[name='sq:environment']");
  if (!envMeta) {
    return null;
  }

  return JSON.parse(envMeta.getAttribute('content'));
};

const getDomain = (otherSubdomain) => {
  const { env, app_subdomain } = getEnvironment();
  const host =
    env === 'production' ? BASE_DOMAIN.PRODUCTION : BASE_DOMAIN.STAGING;

  // other subdomains do not need the 'app' subdomain too
  const subdomain =
    otherSubdomain || otherSubdomain === '' ? otherSubdomain : app_subdomain;

  return `${subdomain}${host}`;
};

const getHost = () => {
  return getEnvironment().env === 'production'
    ? 'https://api.squareup.com'
    : 'https://api.squareupstaging.com';
};

export { BASE_DOMAIN, getEnvironment, getDomain, getHost };
